import React from "react";

import { usePrefetchLabels } from "../../../hooks/useLabels";

import { DefaultHeader } from "./default-header";
import { SelectionHeader } from "./selection-header";

import { labels } from "./labels";

export function PhotoSelectionHeaderContainer({
	onClose,
	onBack,
	onRemove,
	onSelect,
	hasPhotos,
	canSelect,
	nbrOfSelectedPhotos,
}: {
	onClose(hasPendingUploads: false | undefined): void;
	onBack(): void;
	onRemove(): void;
	onSelect(): void;
	hasPhotos: boolean;
	canSelect?: boolean;
	nbrOfSelectedPhotos: number;
}) {
	// Prefetch labels for when SelectionModus is started
	usePrefetchLabels(Object.values(labels));

	return (
		<>
			{canSelect ? (
				<SelectionHeader
					nbrOfSelectedPhotos={nbrOfSelectedPhotos}
					onBack={onBack}
					onRemove={onRemove}
				/>
			) : (
				<DefaultHeader onClose={onClose} onSelect={onSelect} hasPhotos={hasPhotos} />
			)}
		</>
	);
}
